import { Ruler } from 'component/Ruler'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n, I18nKey } from 'i18n'
import { ChangeEvent, useState } from 'react'

type Props = {
  label?: I18nKey
  unit: I18nKey
  value: number
  min: number
  max: number
  onChange(value: number): void
}

export function Measure(props: Props) {
  const { label, unit, value, min, max, onChange } = props
  const [text, setText] = useState<string | null>(null)

  const onFocus = () => {
    setText(String(value))
  }

  const onBlur = () => {
    setText(null)
  }

  const onValue = (value: number) => {
    onChange(Math.min(max, Math.max(min, value)))
  }

  const onInput = (event: ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value.replace(/\D/g, '')
    setText(raw)
    onValue(Number(raw) || 0)
  }

  return <Vertical gap={24}>
    <Space gap={8} center>
      <Typo size={48} medium>
        {value}
      </Typo>
      <Typo size={32} medium secondary>
        {i18n(unit)}
      </Typo>
    </Space>
    <Ruler value={value} min={min} max={max} onChange={onChange} />
  </Vertical>
}
